import { Dayjs } from 'dayjs';

export interface DoubleDate {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
}

export enum DoubleDateMode {
  DELIVERY_DATE = 'delivery date',
  CREATION_DATE = 'creation date',
  PAYMENT_DATE = 'payment date',
}

export interface DoubleDateWithMode {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  mode: DoubleDateMode;
}
